import React from 'react';
import Lottie from "lottie-react";
import animationData from "./Animation.json";

const LoadingSpinner = () => {
    return (
        <div className="Body">
            <Lottie animationData={animationData} isClickToPauseDisabled={true}
                    loop={false}
                    style={{
                        position: "absolute",
                        width: "100%",
                        height: "100%",
                        zIndex: 20,
                    }}
            />
        </div>
    );
};

export default LoadingSpinner;
